(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('click', (event) => {
    document.querySelectorAll('.gear-menu[open]').forEach((menu) => {
      if (!menu.contains(event.target)) menu.removeAttribute('open');
    });
  });

  document.addEventListener('keyup', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.gear-menu[open]').forEach((menu) => menu.removeAttribute('open'));
  });

  document.querySelectorAll('[data-predictive-search]').forEach((component) => {
    const input = component.querySelector('[data-predictive-search-input]');
    const results = component.querySelector('[data-predictive-search-results]');
    let timer;
    let controller;

    input?.addEventListener('input', () => {
      window.clearTimeout(timer);
      const query = input.value.trim();
      if (query.length < 2) {
        results.innerHTML = '';
        return;
      }

      timer = window.setTimeout(async () => {
        controller?.abort();
        controller = new AbortController();
        const url = `${results.dataset.predictiveUrl}?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=6&section_id=predictive-search`;

        try {
          const response = await fetch(url, { signal: controller.signal });
          const text = await response.text();
          const documentFragment = new DOMParser().parseFromString(text, 'text/html');
          const incoming = documentFragment.querySelector('#PredictiveSearchResults');
          results.innerHTML = incoming ? incoming.outerHTML : '';
        } catch (error) {
          if (error.name !== 'AbortError') results.innerHTML = '';
        }
      }, 180);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('majbwr-product-recommendations')) {
    customElements.define('majbwr-product-recommendations', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.loaded === 'true') return;
        this.dataset.loaded = 'true';

        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const documentFragment = new DOMParser().parseFromString(text, 'text/html');
            const recommendations = documentFragment.querySelector('majbwr-product-recommendations');
            const resultGrid = recommendations?.querySelector('[data-recommendation-grid]');

            if (resultGrid?.querySelector('.product-card')) this.innerHTML = recommendations.innerHTML;
          })
          .catch(() => {});
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recently-viewed-products"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-recently-viewed]').forEach((section) => {
    const currentData = section.querySelector('[data-current-product]');
    const grid = section.querySelector('[data-recently-viewed-grid]');
    if (!currentData || !grid) return;

    try {
      const current = JSON.parse(currentData.textContent);
      const stored = JSON.parse(localStorage.getItem('majbwr_recently_viewed') || '[]');
      const previous = stored.filter((item) => String(item.id) !== String(current.id)).slice(0, 4);

      previous.forEach((item) => {
        const article = document.createElement('article');
        article.className = 'product-card';

        const link = document.createElement('a');
        link.href = item.url;
        link.setAttribute('aria-label', item.title);

        const media = document.createElement('div');
        media.className = 'product-card__media';
        if (item.image) {
          const image = document.createElement('img');
          image.src = item.image;
          image.alt = item.title;
          image.loading = 'lazy';
          image.width = 900;
          image.height = 1125;
          media.appendChild(image);
        }

        const info = document.createElement('div');
        info.className = 'product-card__info';
        const title = document.createElement('h3');
        title.className = 'product-card__title';
        title.textContent = item.title;
        const price = document.createElement('div');
        price.className = 'price';
        price.textContent = item.price;
        info.append(title, price);
        link.append(media, info);
        article.appendChild(link);
        grid.appendChild(article);
      });

      if (previous.length) section.hidden = false;

      const next = [current, ...previous].slice(0, 8);
      localStorage.setItem('majbwr_recently_viewed', JSON.stringify(next));
    } catch (error) {
      section.hidden = true;
    }
  });

  } catch(e) { console.error(e); }
})();
})();
